// Paleta padrão do seletor de cor das rotas (Tailwind 500). Admin pode digitar qualquer #RRGGBB.
export const ROTA_PALETTE = [
  "#EF4444", "#F97316", "#F59E0B", "#84CC16", "#22C55E", "#14B8A6",
  "#06B6D4", "#3B82F6", "#6366F1", "#A855F7", "#EC4899", "#64748B",
];

export const isHex = (v) => /^#[0-9a-fA-F]{6}$/.test(v || "");

export const emptyRota = () => ({ nome: "", cor: "#3B82F6", ativa: true, bairro_ids: [] });
